/* Agatha redesign (test theme): product page, brands A–Z and policy pages. Owner: product-pages builder.
   Loaded (deferred) on every page by snippets/agatha-head.liquid; each part runs only where its markup is.

   Product page (markup from snippets/agatha-size-suggest.liquid, agatha-product-facts.liquid):
   - approximate age under each size pill, the option's current value in its legend;
   - the available size that fits the remembered age (Agatha.getAge) is preselected by clicking
     Dawn's own radio (product-info.js then updates price, buttons and URL), and named in
     handwriting under the sizes; re-applied every time Dawn re-renders <variant-selects>;
   - "Pour quel âge" fact from the product's own size labels;
   - desktop gallery arrows and "1 / n" counter; phone buy bar once the main button scrolls away.
   Brands page: find-a-brand filter. Policy pages: tabs built from the footer's policy links. */
(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };
  var arr = function (list) { return Array.prototype.slice.call(list || []); };

  /* ---------- ages ---------- */
  // Months covered by each prototype age (data/taxonomy.js AGES).
  var AGE_MONTHS = [
    ['naissance', 0, 3], ['6-mois', 3, 9], ['1-an', 9, 18], ['2-ans', 18, 36], ['4-ans', 36, 60],
    ['6-ans', 60, 84], ['8-ans', 84, 108], ['10-ans', 108, 132], ['12-ans', 132, 192],
  ];
  var HEIGHT_TO_MONTHS = [
    [50, 0], [61, 3], [67, 6], [75, 12], [82, 18], [87, 24], [96, 36], [103, 48], [110, 60], [116, 72],
    [122, 84], [128, 96], [133, 108], [138, 120], [144, 132], [149, 144], [156, 156], [163, 168], [170, 192],
  ];
  function heightMonths(cm) {
    var p = HEIGHT_TO_MONTHS;
    if (cm <= p[0][0]) return 0;
    for (var i = 0; i < p.length - 1; i++) {
      if (cm <= p[i + 1][0]) return p[i][1] + ((p[i + 1][1] - p[i][1]) * (cm - p[i][0])) / (p[i + 1][0] - p[i][0]);
    }
    return 192;
  }
  var MW = '(?:m|mois|months?|mo)\\b';
  var YW = '(?:ans?|y|years?|a)\\b';
  var TW = '(?:t|tonnes?)\\b';
  var full = function (re) { return new RegExp('^(?:' + re + ')$'); };
  var RX = {
    skip: /pièce|pieces|boîte|kg|pointure|x-|\*|juillet/,
    fois: full('(\\d+)\\s*(?:à|-)\\s*(\\d+)\\s*fois'),
    millions: full('(\\d+)\\s*millions?'),
    around: /\((?:autour de )?(\d+)\s*an/,
    paren: /\(([^)]*)\)/,
    slash: full('(\\d+)/(\\d+)'),
    monthsToYears: full('(\\d+)\\s*' + MW + '\\s*(?:à|-|to)\\s*(\\d+)\\s*' + YW),
    monthRange: new RegExp('^(\\d+)\\s*m?\\s*(?:-|à|–|/)\\s*(\\d+)\\s*' + MW),
    month: full('(\\d+)\\s*' + MW),
    toddlerRange: full('(\\d+)\\s*(?:-|/|à)\\s*(\\d+)\\s*' + TW),
    toddler: full('(\\d+)\\s*' + TW),
    yearRange: full('(\\d+)\\s*(?:' + YW + ')?\\s*(?:-|/|à|to)\\s*(\\d+)\\s*' + YW),
    year: full('(\\d+)\\s*' + YW),
    cm: full('(\\d{3})'),
    bare: full('(\\d+)x?'),
    bareRange: full('(\\d+)\\s*(?:-|à)\\s*(\\d+)'),
  };
  // JS port of tools/build_data.py parse_age: [lo, hi] in months, or null. A third value is the
  // oldest age written on the label, in months ("3-5T" -> 60, "18-36M" -> 36): year forms add a
  // year to hi, so hi alone cannot tell "36 months" from "2 years" (#140).
  function monthsOf(label) {
    var s = String(label == null ? '' : label).toLowerCase().replace(/\u00a0/g, ' ').replace(/ old/g, '').trim();
    var m, n, a, b;
    if (!s || RX.skip.test(s)) return null;
    if ((m = s.match(RX.fois))) return [12 * +m[1], 12 * +m[2] + 12, 12 * +m[2]];
    if (s.indexOf('fois') !== -1) return null;
    if ((m = s.match(RX.millions))) { n = +m[1]; return n <= 12 ? [Math.max(0, n - 3), n, n] : [n - 6, n, n]; }
    if (s === 'nb' || s === 'nouveau-né' || s === 'newborn' || s === 'prématuré') return [0, 3, 0];
    if ((m = s.match(RX.around))) { n = +m[1]; return [12 * n, 12 * n + 12, 12 * n]; }
    m = s.match(RX.paren);
    if (m && /\d/.test(m[1]) && !RX.slash.test(m[1].trim())) {
      var inner = monthsOf(m[1]);
      if (inner) return inner;
    }
    if (m && RX.slash.test(m[1].trim())) {
      var sm = m[1].trim().match(RX.slash);
      return [12 * +sm[1], 12 * +sm[2] + 12, 12 * +sm[2]];
    }
    s = s.replace(/\(.*?\)/g, '').trim();
    if (s.indexOf('nb') === 0) s = s.replace(/nb/g, '0m');
    if ((m = s.match(RX.monthsToYears))) return [+m[1], 12 * +m[2] + 12, 12 * +m[2]];
    if ((m = s.match(RX.monthRange))) return [+m[1], +m[2], +m[2]];
    if ((m = s.match(RX.month))) { n = +m[1]; return n <= 12 ? [Math.max(0, n - 3), n, n] : [n - 6, n, n]; }
    if ((m = s.match(RX.toddlerRange))) return [12 * +m[1], 12 * +m[2] + 12, 12 * +m[2]];
    if ((m = s.match(RX.toddler))) { n = +m[1]; return [12 * n, 12 * n + 12, 12 * n]; }
    if ((m = s.match(RX.yearRange))) return [12 * +m[1], 12 * +m[2] + 12, 12 * +m[2]];
    if ((m = s.match(RX.year))) { n = +m[1]; return [12 * n, 12 * n + 12, 12 * n]; }
    if ((m = s.match(RX.cm)) && +m[1] >= 50 && +m[1] <= 176) {
      n = +m[1];
      return [Math.round(heightMonths(n - 5)), Math.round(heightMonths(n + 5)), Math.round(heightMonths(n + 5))];
    }
    if ((m = s.match(RX.bare)) && +m[1] >= 1 && +m[1] <= 16) { n = +m[1]; return [12 * n, 12 * n + 12, 12 * n]; }
    if ((m = s.match(RX.bareRange))) {
      a = +m[1]; b = +m[2];
      if (a >= 1 && a < b && b <= 16) return [12 * a, 12 * b + 12, 12 * b];
    }
    return null;
  }
  function idsOfRange(r) {
    return AGE_MONTHS.filter(function (x) { return r[0] < x[2] && r[1] > x[1]; }).map(function (x) { return x[0]; });
  }
  // Age ids of a size label: the shared parser (agatha-core.js) when present, else the local port.
  function ageIdsOf(label) {
    try {
      if (window.Agatha && typeof window.Agatha.parseAge === 'function') {
        var ids = window.Agatha.parseAge(label);
        if (Array.isArray(ids)) return ids;
      }
    } catch (e) { /* fall back */ }
    var r = monthsOf(label);
    return r ? idsOfRange(r) : [];
  }
  function rememberedAge() {
    try {
      if (window.Agatha && typeof window.Agatha.getAge === 'function') return window.Agatha.getAge() || null;
    } catch (e) { /* fall back */ }
    try { return window.localStorage.getItem('agatha-age'); } catch (e) { return null; }
  }
  var LABEL_HAS_AGE = /mois|ans\b|month|year/i;
  var SIZE_NAME = /^(taille|tailles|size|sizes|grandeur|âge|age)\b/i;
  // Option fieldsets of one <variant-selects> (never the quantity field).
  var fieldsets = function (vs) {
    return vs ? arr(vs.querySelectorAll('.product-form__input:not(.product-form__quantity)')) : [];
  };

  /* ---------- product page ---------- */
  function initProduct() {
    var dataEl = document.querySelector('script[data-ag-pdp]');
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var info = dataEl.closest('product-info') || document.querySelector('product-info[id^="MainProduct-"]');
    if (!info) return;
    var sid = cfg.sectionId || info.dataset.section;
    var T = cfg.i18n || {};
    var variants = cfg.variants || [];
    var fmt = function (s, v) { return String(s || '').replace(/%(\w+)%/g, function (_, k) { return v[k] != null ? v[k] : ''; }); };
    var ageName = function (id) { return (T.ages && T.ages[id]) || id; };
    // Years rounded to the nearest half ("11½"); equal ends collapse ("11½ ans", never "11½–11½").
    var toHalf = function (n) { return Math.round(n * 2) / 2; };
    var half = function (h) { return h % 1 ? (Math.floor(h) || '') + '½' : String(h); };
    var hintOf = function (r) {
      if (!r) return '';
      if (r[1] <= 24) return r[0] === r[1] ? r[0] + ' ' + T.monthsShort : r[0] + '–' + r[1] + ' ' + T.monthsShort;
      var a = toHalf(r[0] / 12), b = toHalf((r[2] != null ? r[2] : r[1] - 12) / 12);
      return b <= a ? half(a) + ' ' + T.yearsShort : half(a) + '–' + half(b) + ' ' + T.yearsShort;
    };

    // Which size labels may be read as ages. Never on adult products (cfg.noAge: Parents department,
    // maternity, whose "2" … "16" are women's sizes). A bare three-digit label ("130") is a height
    // only when the option says so (cm, hauteur); otherwise it can be a foot length (clogs).
    // On footwear (cfg.footwear) a bare number is a shoe size, never an age.
    var opts = cfg.options || [];
    var noAge = cfg.noAge === true;
    var footwear = cfg.footwear === true;
    var CM_NAME = /\bcm\b|hauteur|height|stature/i;
    var BARE_3 = /^\s*\d{3}\s*$/;
    var BARE_NUM = /^\s*\d+\s*(?:(?:-|–|à|\/)\s*\d+\s*)?x?\s*$/i;
    function ageable(i, label) {
      if (noAge) return false;
      var s = String(label == null ? '' : label);
      if (BARE_3.test(s) && !CM_NAME.test(String((opts[i] && opts[i].name) || ''))) return false;
      if (footwear && BARE_NUM.test(s)) return false;
      return true;
    }
    var monthsAt = function (i, label) { return ageable(i, label) ? monthsOf(label) : null; };
    var idsAt = function (i, label) { return ageable(i, label) ? ageIdsOf(label) : []; };

    // Which option holds sizes: a size-like name whose values read as ages. nameIdx: the size-like
    // option even when its values are not ages (the buy bar still names the chosen size).
    var sizeIdx = -1;
    var nameIdx = -1;
    opts.forEach(function (o, i) {
      if (!SIZE_NAME.test(String(o.name).trim())) return;
      if (nameIdx === -1) nameIdx = i;
      if (sizeIdx !== -1) return;
      if (variants.some(function (v) { return monthsAt(i, v.options[i]) || idsAt(i, v.options[i]).length; })) sizeIdx = i;
    });

    var ageId = rememberedAge();
    var ageRow = AGE_MONTHS.filter(function (x) { return x[0] === ageId; })[0];
    var urlHasVariant = /[?&]variant=/.test(window.location.search);
    var preselected = false;

    var currentSelects = function () {
      var all = arr(info.querySelectorAll('variant-selects'));
      return all.filter(function (el) { return el.style.display !== 'none'; }).pop() || all.pop() || null;
    };
    var checkedValues = function () {
      return fieldsets(currentSelects()).map(function (fs) {
        var c = fs.querySelector('input[type="radio"]:checked');
        if (c) return c.value;
        var sel = fs.querySelector('select');
        return sel ? sel.value : null;
      });
    };

    // The suggested variant: available, fits the remembered age, same other options as now
    // (when possible), closest to the middle of that age.
    function suggestion() {
      if (sizeIdx === -1 || !ageRow) return null;
      var mid = (ageRow[1] + ageRow[2]) / 2;
      var now = checkedValues();
      var fits = variants.filter(function (v) {
        return v.available && idsAt(sizeIdx, v.options[sizeIdx]).indexOf(ageId) !== -1;
      });
      var same = fits.filter(function (v) {
        return now.every(function (val, i) { return i === sizeIdx || val == null || v.options[i] === val; });
      });
      var pool = same.length ? same : fits;
      var dist = function (v) { var r = monthsAt(sizeIdx, v.options[sizeIdx]); return r ? Math.abs((r[0] + r[1]) / 2 - mid) : 999; };
      pool.sort(function (a, b) { return dist(a) - dist(b); });
      return pool[0] ? { variant: pool[0], sameOthers: same.length > 0 } : null;
    }

    function optLabel(name) {
      var n = String(name).trim().toLowerCase();
      if (n === 'size' || n === 'taille' || (document.documentElement.lang === 'en' && n === 'tailles')) return T.optSize || name;
      if (n === 'color' || n === 'colour' || n === 'couleur' || (document.documentElement.lang === 'en' && n === 'couleurs')) return T.optColor || name;
      if (n === 'title' || n === 'titre') return T.optTitle || name;
      return name;
    }

    // Decorate a <variant-selects> tree (live, or Dawn's freshly fetched copy before it is inserted).
    function decorate(vs) {
      if (!vs || !vs.querySelectorAll) return;
      var sug = suggestion();
      var sugSize = sug ? sug.variant.options[sizeIdx] : null;
      fieldsets(vs).forEach(function (fs, i) {
        var radios = fs.querySelectorAll('input[type="radio"]');
        var legend = fs.querySelector('legend');
        if (legend && !legend.querySelector('.ag-opt__name')) {
          var name = opts[i] ? opts[i].name : legend.textContent.replace(/:\s*$/, '').trim();
          var checked = fs.querySelector('input[type="radio"]:checked');
          var swatchVal = legend.querySelector('[data-selected-value]');
          legend.textContent = '';
          var nm = document.createElement('span');
          nm.className = 'ag-opt__name';
          nm.textContent = optLabel(name);
          legend.appendChild(nm);
          var val = swatchVal || document.createElement('span');
          val.classList.add('ag-opt__value');
          val.setAttribute('data-selected-value', '');
          if (!swatchVal) val.textContent = checked ? checked.dataset.agLabel || checked.value : '';
          legend.appendChild(val);
        }
        fs.classList.toggle('ag-opt--single', radios.length === 1);
        if (i !== sizeIdx) return;
        fs.classList.add('ag-opt--size');
        arr(radios).forEach(function (input) {
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (!label) return;
          label.classList.toggle('ag-suggested', sugSize != null && input.value === sugSize);
          if (label.querySelector('.ag-age-hint') || LABEL_HAS_AGE.test(input.value)) return;
          var hint = hintOf(monthsAt(i, input.value));
          if (!hint) return;
          var small = document.createElement('small');
          small.className = 'ag-age-hint';
          small.textContent = hint;
          label.insertBefore(small, label.querySelector('.label-unavailable'));
          label.classList.add('ag-has-hint');
        });
      });
    }

    var suggestBox = info.querySelector('[data-ag-suggest]');
    function renderSuggestion() {
      if (!suggestBox) return;
      var sug = suggestion();
      var line = suggestBox.querySelector('[data-ag-suggest-line]');
      var note = suggestBox.querySelector('[data-ag-size-note]');
      var hasHints = !!info.querySelector('.ag-opt--size .ag-age-hint');
      line.textContent = '';
      if (sug) {
        line.appendChild(document.createTextNode(fmt(T.suggested, { age: ageName(ageId).toLowerCase() }) + ' '));
        var strong = document.createElement('strong');
        strong.textContent = sug.variant.options[sizeIdx];
        line.appendChild(strong);
      }
      line.hidden = !sug;
      note.hidden = !hasHints;
      suggestBox.hidden = !sug && !hasHints;
    }

    function preselect() {
      if (preselected || urlHasVariant) return;
      preselected = true;
      var sug = suggestion();
      if (!sug || !sug.sameOthers) return;
      var fs = fieldsets(currentSelects())[sizeIdx];
      if (!fs) return;
      var target = arr(fs.querySelectorAll('input[type="radio"]')).filter(function (r) {
        return r.value === sug.variant.options[sizeIdx];
      })[0];
      if (target && !target.checked) {
        keepPlace(target.id);
        target.click();
      }
    }

    // Integration fix: after a variant change Dawn's product-info calls focus() on the clicked radio
    // (product-info.js renderProductInfo), which scrolled a phone down to the size picker on load.
    // For this automatic click only, skip that one focus call: the shopper did not choose the size.
    function keepPlace(id) {
      var proto = window.HTMLElement && HTMLElement.prototype;
      if (!proto || typeof proto.focus !== 'function') return;
      var orig = proto.focus;
      var restore = function () { if (proto.focus === skip) proto.focus = orig; };
      var skip = function () {
        if (this && this.id === id) { restore(); return; }
        return orig.apply(this, arguments);
      };
      proto.focus = skip;
      setTimeout(restore, 8000);
    }

    // "Pour quel âge": the ages the product's sizes cover, from the real bounds of the size labels
    // (#140: the toise buckets turned "3-12M … 3-5T" into "6 mois à 6 ans"): the youngest age the
    // smallest size covers, to the oldest age written on the largest one.
    var unitOf = function (id) { return String(ageName(id)).toLowerCase().split(' ').slice(1).join(' '); };
    function ageWords(m) {
      if (m <= 0) return String(ageName('naissance')).toLowerCase();
      if (m === 12) return String(ageName('1-an')).toLowerCase();
      if (m < 24) return m + ' ' + unitOf('6-mois');
      return half(toHalf(m / 12)) + ' ' + unitOf('4-ans');
    }
    function renderAgesFact() {
      var li = info.querySelector('[data-ag-ages-fact]');
      if (!li || sizeIdx === -1) return;
      var lo = Infinity, top = -Infinity;
      variants.forEach(function (v) {
        var r = monthsAt(sizeIdx, v.options[sizeIdx]);
        if (!r) return;
        lo = Math.min(lo, r[0]);
        top = Math.max(top, r[2] != null ? r[2] : r[1]);
      });
      if (lo === Infinity) return;
      var first = ageWords(lo);
      var last = ageWords(top);
      var text;
      if (first === last) text = fmt(T.sizesOne, { age: last });
      else if (top >= 144) text = fmt(T.sizesUp, { from: first });
      else {
        // "3 à 5 ans" rather than "3 ans à 5 ans"
        [unitOf('4-ans'), unitOf('6-mois')].forEach(function (u) {
          u = ' ' + u;
          if (u.trim() && first.slice(-u.length) === u && last.slice(-u.length) === u) first = first.slice(0, -u.length);
        });
        text = fmt(T.sizesRange, { from: first, to: last });
      }
      li.querySelector('[data-ag-ages-text]').textContent = text + '.';
      li.hidden = false;
    }

    decorate(currentSelects());
    renderSuggestion();
    renderAgesFact();

    // Dawn swaps <variant-selects> on every change: decorate the fetched copy before it is shown,
    // and again once inserted (belt and braces), then refresh the suggestion line.
    if (typeof info.addPreProcessCallback === 'function') {
      info.addPreProcessCallback(function (html) {
        try {
          if (html && html.tagName === 'VARIANT-SELECTS') decorate(html);
          else if (html && html.querySelector) decorate(html.querySelector('variant-selects'));
        } catch (e) { /* never block Dawn */ }
      });
    }
    var container = info.querySelector('.product__info-container') || info;
    new MutationObserver(function (records) {
      var changed = records.some(function (r) {
        return arr(r.addedNodes).some(function (n) { return n.tagName === 'VARIANT-SELECTS'; });
      });
      if (!changed) return;
      decorate(currentSelects());
      renderSuggestion();
    }).observe(container, { childList: true });

    var defined = window.customElements && customElements.whenDefined
      ? Promise.race([customElements.whenDefined('product-info'), new Promise(function (r) { setTimeout(r, 1500); })])
      : Promise.resolve();
    defined.then(function () { setTimeout(preselect, 0); });

    initGallery(sid, T);
    initBuybar(sid, info, sizeIdx !== -1 ? sizeIdx : nameIdx);
  }

  /* ---------- gallery: arrows and counter on desktop ---------- */
  function initGallery(sid, T) {
    var viewer = document.getElementById('GalleryViewer-' + sid);
    var list = document.getElementById('Slider-Thumbnails-' + sid);
    if (!viewer || !list) return;
    var thumbs = function () {
      return arr(list.querySelectorAll('.thumbnail-list__item')).filter(function (li) {
        return window.getComputedStyle(li).display !== 'none';
      }).map(function (li) { return li.querySelector('button.thumbnail'); }).filter(Boolean);
    };
    if (list.querySelectorAll('.thumbnail-list__item').length < 2) return;
    var nav = document.createElement('div');
    nav.className = 'ag-gnav';
    var chevron = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>';
    nav.innerHTML = '<button type="button" class="ag-gnav__btn ag-gnav__btn--prev" data-step="-1">' + chevron + '</button>'
      + '<button type="button" class="ag-gnav__btn ag-gnav__btn--next" data-step="1">' + chevron + '</button>'
      + '<span class="ag-gnav__count" aria-hidden="true"></span>';
    nav.children[0].setAttribute('aria-label', T.prev || 'Previous');
    nav.children[1].setAttribute('aria-label', T.next || 'Next');
    viewer.appendChild(nav);
    var count = nav.querySelector('.ag-gnav__count');
    var index = function (all) {
      for (var i = 0; i < all.length; i++) if (all[i].getAttribute('aria-current') === 'true') return i;
      return 0;
    };
    var sync = function () {
      var all = thumbs();
      nav.hidden = all.length < 2;
      count.textContent = (index(all) + 1) + ' / ' + all.length;
    };
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-step]');
      if (!btn) return;
      var all = thumbs();
      var next = all[(index(all) + +btn.dataset.step + all.length) % all.length];
      if (next) next.click();
    });
    new MutationObserver(sync).observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
    sync();
  }

  /* ---------- phone buy bar ---------- */
  function initBuybar(sid, info, sizeIdx) {
    var submitOf = function () { return document.getElementById('ProductSubmitButton-' + sid); };
    var submit = submitOf();
    if (!submit) return;
    var bar = document.createElement('div');
    bar.className = 'ag-buybar';
    bar.setAttribute('aria-hidden', 'true');
    bar.inert = true;
    bar.innerHTML = '<div class="ag-buybar__info"><b data-bb-price></b><span data-bb-size></span></div>'
      + '<button type="button" class="button ag-buybar__btn"></button>';
    document.body.appendChild(bar);
    var btn = bar.querySelector('button');
    btn.addEventListener('click', function () { var s = submitOf(); if (s) s.click(); });
    var queued = false;
    var sync = function () {
      queued = false;
      var s = submitOf();
      if (!s) return;
      var label = s.querySelector('span');
      btn.textContent = (label ? label.textContent : s.textContent).trim();
      btn.disabled = s.hasAttribute('disabled');
      var price = document.querySelector('#price-' + sid + ' .price-item--last');
      bar.querySelector('[data-bb-price]').textContent = price ? price.textContent.trim() : '';
      var sizeText = '';
      if (sizeIdx !== -1) {
        var vs = arr(info.querySelectorAll('variant-selects')).filter(function (el) { return el.style.display !== 'none'; }).pop();
        var fs = fieldsets(vs)[sizeIdx];
        var c = fs && fs.querySelector('input[type="radio"]:checked');
        if (c && fs.querySelectorAll('input[type="radio"]').length > 1) sizeText = c.value;
      }
      bar.querySelector('[data-bb-size]').textContent = sizeText;
    };
    var queue = function () { if (!queued) { queued = true; window.setTimeout(sync, 30); } };
    new MutationObserver(queue).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    info.addEventListener('change', queue);
    sync();
    var phone = window.matchMedia('(max-width: 989px)');
    var past = false;
    var apply = function () {
      var on = past && phone.matches;
      if (bar.classList.contains('is-on') === on) return;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      bar.inert = !on;
      document.body.classList.toggle('ag-buybar-on', on);
    };
    // Shown once the main button has scrolled above the top of the screen (prototype syncBuybar).
    var check = function () {
      var s = submitOf();
      past = !!s && s.getBoundingClientRect().bottom < 0;
      apply();
    };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    if (phone.addEventListener) phone.addEventListener('change', check);
    check();
  }

  /* ---------- brands A–Z: find a brand ---------- */
  function initBrands() {
    var root = document.querySelector('[data-ag-brands]');
    if (!root) return;
    var input = root.querySelector('[data-ag-brand-find]');
    if (!input) return;
    var norm = function (s) { return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); };
    var items = arr(root.querySelectorAll('[data-ag-brand]')).map(function (li) {
      return { li: li, key: norm(li.getAttribute('data-ag-brand')) };
    });
    var groups = arr(root.querySelectorAll('[data-ag-letter]'));
    var jumps = arr(root.querySelectorAll('[data-ag-jump]'));
    var none = root.querySelector('[data-ag-brands-none]');
    input.addEventListener('input', function () {
      var q = norm(input.value.trim());
      items.forEach(function (it) { it.li.hidden = q !== '' && it.key.indexOf(q) === -1; });
      var shown = {};
      groups.forEach(function (g) {
        var any = g.querySelector('[data-ag-brand]:not([hidden])');
        g.hidden = !any;
        if (any) shown[g.getAttribute('data-ag-letter')] = true;
      });
      jumps.forEach(function (a) { a.hidden = !shown[a.getAttribute('data-ag-jump')]; });
      if (none) none.hidden = Object.keys(shown).length > 0;
    });
  }

  /* ---------- policy pages: tabs from the footer's policy links ---------- */
  function initPolicyTabs() {
    if (!document.body.classList.contains('ag-page-policy')) return;
    var box = document.querySelector('.shopify-policy__container');
    if (!box || box.querySelector('.ag-policy-tabs')) return;
    var order = ['shipping-policy', 'refund-policy', 'privacy-policy', 'terms-of-service'];
    var found = {};
    // Footer links first (their wording is the store's menu), then any other link on the page.
    var links = arr(document.querySelectorAll('footer a[href*="/policies/"], [id*="footer"] a[href*="/policies/"]'))
      .concat(arr(document.querySelectorAll('a[href*="/policies/"]')));
    links.forEach(function (a) {
      if (box.contains(a) || a.closest('cart-drawer, .cart-drawer, .drawer')) return;
      var key = (a.getAttribute('href').match(/\/policies\/([a-z-]+)/) || [])[1];
      if (key && order.indexOf(key) !== -1 && !found[key] && a.textContent.trim()) {
        found[key] = { href: a.getAttribute('href'), text: a.textContent.trim() };
      }
    });
    var keys = order.filter(function (k) { return found[k]; });
    if (keys.length < 2) return;
    var here = (window.location.pathname.match(/\/policies\/([a-z-]+)/) || [])[1];
    var nav = document.createElement('nav');
    nav.className = 'ag-policy-tabs';
    keys.forEach(function (k) {
      var a = document.createElement('a');
      a.href = found[k].href;
      a.textContent = found[k].text;
      if (k === here) a.setAttribute('aria-current', 'page');
      nav.appendChild(a);
    });
    box.insertBefore(nav, box.firstChild);
  }

  /* ---------- story page: headings the store wrote as emoji-led paragraphs ---------- */
  // The page text has no <h2>: its section titles are short paragraphs that start with an emoji
  // ("✨ Une nouvelle équipe, un nouveau départ"). Show those as subheadings and the first real
  // paragraph as the lead. Text is untouched; only classes are added.
  function initStory() {
    var prose = document.querySelector('.ag-prose--story');
    if (!prose) return;
    var pict;
    try { pict = new RegExp('^\\p{Extended_Pictographic}', 'u'); } catch (e) { return; }
    var lead = null;
    var first = null;
    // The EN text nests its paragraphs in old-theme <div>s and uses <h1>/<h2>; the FR text has
    // only <p>. Walk every block in reading order.
    arr(prose.querySelectorAll('p, h1, h2, h3')).forEach(function (el) {
      var t = el.textContent.replace(/\s+/g, ' ').trim();
      if (!t) return;
      if (!first) { first = el; el.classList.add('ag-prose__first'); }
      if (el.tagName !== 'P') { el.classList.add('ag-prose__head'); return; }
      if (pict.test(t) && t.length <= 90 && !/[.!?;:]$/.test(t) && !el.querySelector('br')) {
        el.classList.add('ag-prose__head');
      } else if (!lead) {
        lead = el;
        el.classList.add('ag-prose__lead');
      }
    });
    prose.classList.add('is-enhanced');
  }

  // Integration fix: some policy texts (FR shipping) open with their own <h1> under Shopify's title
  // <h1>. Keep one h1: the text's own becomes a paragraph with the same subtitle look.
  // The refund policy opens with the same line as an <h2> ("Politique de remboursement — Boutique
  // Agatha"): a leading heading that ends with the store's name gets the same subtitle look.
  function initPolicyHeading() {
    if (!document.body.classList.contains('ag-page-policy')) return;
    var toSub = function (h) {
      var p = document.createElement('p');
      p.className = 'ag-policy-sub';
      p.innerHTML = h.innerHTML;
      h.parentNode.replaceChild(p, h);
    };
    var body = document.querySelector('.shopify-policy__body');
    if (!body) return;
    var lead = arr(body.querySelectorAll('h1, h2, h3, h4, p')).filter(function (el) {
      return el.textContent.trim();
    })[0];
    if (lead && /^H[2-4]$/.test(lead.tagName)
      && /\s[—–-]\s*(?:boutique\s+)?agatha(?:\s+boutique)?\s*$/i.test(lead.textContent.replace(/\s+/g, ' ').trim())) {
      toSub(lead);
    }
    arr(body.querySelectorAll('h1')).forEach(toSub);
  }

  ready(function () {
    try { initPolicyHeading(); } catch (e) { if (window.console) console.warn('agatha-product policy heading', e); }
    try { initStory(); } catch (e) { if (window.console) console.warn('agatha-product story', e); }
    try { initProduct(); } catch (e) { if (window.console) console.warn('agatha-product', e); }
    try { initBrands(); } catch (e) { if (window.console) console.warn('agatha-product brands', e); }
    try { initPolicyTabs(); } catch (e) { if (window.console) console.warn('agatha-product policy', e); }
  });
})();
